import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import {
  setLanguageToLegalPolicyUrl,
  setLanguageToLegalPolicyUrlEnd,
  setLanguageToLegalTermsUrl,
} from '../../utils/helpers';
import { END_USERS_ROLE } from '../../utils/constants';
import { useStore } from '../../store';
import { observer } from 'mobx-react-lite';

const Footer = observer(({ openModal }) => {
  const { t, i18n } = useTranslation();
  const { rootStore } = useStore();
  const isEndUser = rootStore.profileStore.connection === END_USERS_ROLE;

  const openCookiesModal = () => {
    openModal();
  };

  const termsUrl = setLanguageToLegalTermsUrl(i18n.language);
  const privacyUrl = setLanguageToLegalPolicyUrl(i18n.language);
  const privacyUrlEnd = setLanguageToLegalPolicyUrlEnd(i18n.language);

  return (
    <footer className="account-footer">
      <div>
        <div className="cursor-pointer" onClick={openCookiesModal}>
          {t('menu.cookies')}
        </div>
        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
          {t('footer.termsOfUse.text')}
        </a>
        <a href={isEndUser ? privacyUrlEnd : privacyUrl} target="_blank" rel="noopener noreferrer">
          {t('footer.privacyPolicy.text')}
        </a>
        <a href={t('footer.gdpr.url')} target="_blank" rel="noopener noreferrer">
          {t('footer.gdpr.text')}
        </a>
        <a href={t('footer.impressum.url')} target="_blank" rel="noopener noreferrer">
          {t('footer.impressum.text')}
        </a>
        <span>&copy; {new Date().getFullYear()} Feller AG</span>
      </div>
    </footer>
  );
});

export default Footer;
